import * as O from 'fp-ts/lib/Option';
import {Commission} from 'Agent/Commissions/models/Commission';
import {AsyncPage, Empty} from 'Core/models/Async';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import {Sort} from 'Shared/components/PagedView/Table/Sort';


export enum CommissionActionType {
  GET_EARNED_COMMISSIONS = 'commission/GET_EARNED_COMMISSIONS',
  GET_ADVANCED_COMMISSIONS = 'commission/GET_ADVANCED_COMMISSIONS',
  GET_SISENSE_COMMISSIONS = 'commission/GET_SISENSE_COMMISSIONS',
  CHANGE_EARNED_COMMISSIONS = 'commission/CHANGE_EARNED_COMMISSIONS',
  CHANGE_ADVANCED_COMMISSIONS = 'commission/CHANGE_ADVANCED_COMMISSIONS',
  CHANGE_SISENSE_COMMISSIONS = 'commission/CHANGE_SISENSE_COMMISSIONS',
  CHANGE_COMMISSION_FILTER = 'commission/CHANGE_COMMISSION_FILTER',
  CHANGE_SORT = 'commission/CHANGE_SORT',
  SISENSE_IS_COMPLETE = "commission/SISENSE_IS_COMPLETE"
}

export const changeCommissionFilter = (commissionFilter: CommissionFilter) =>
  createAction(CommissionActionType.CHANGE_COMMISSION_FILTER, {
    commissionFilter,
  });


export const getEarnedCommissions = (
  agentNumbers: string[],
  isNewYork: boolean,
  encryptedIdentifier: string,
  page?: Page<Commission>,
  filter?: CommissionFilter,
  sort?: Sort
) => {
  return createAction(CommissionActionType.GET_EARNED_COMMISSIONS, {
    agentNumbers,
    isNewYork,
    encryptedIdentifier,
    page,
    filter,
    sort,
  });
};

export const getAdvancedCommissions = (
  agentNumbers: string[],
  isNewYork: boolean,
  encryptedIdentifier: string,
  page?: Page<Commission>,
  filter?: CommissionFilter,
  sort?: Sort
) => {
  return createAction(CommissionActionType.GET_ADVANCED_COMMISSIONS, {
    agentNumbers,
    isNewYork,
    encryptedIdentifier,
    page,
    filter,
    sort,
  });
};


export const getSisenseCommissions = (

) => {
  return createAction(CommissionActionType.GET_SISENSE_COMMISSIONS, {

  });
};

export const changeSort = (sort?: Sort) => createAction(CommissionActionType.CHANGE_SORT, {sort});

export const changeEarnedCommissions = (commissions: AsyncPage<Page<Commission>>) =>
  createAction(CommissionActionType.CHANGE_EARNED_COMMISSIONS, commissions);

export const clearCommissions = () =>
  createAction(CommissionActionType.CHANGE_EARNED_COMMISSIONS, DEFAULT_STATE.commissions);

export const changeAdvancedCommissions = (commissions: AsyncPage<Page<Commission>>) =>
  createAction(CommissionActionType.CHANGE_ADVANCED_COMMISSIONS, commissions);
  export const changeSisenseCommissions = (commissions: any) =>
  createAction(CommissionActionType.CHANGE_SISENSE_COMMISSIONS, commissions);
  export const isSisenseComplete = (isComplete: boolean) => {
    return createAction(CommissionActionType.SISENSE_IS_COMPLETE, {isComplete});
  };
  

export const EmptyCommissionFilter: CommissionFilter = {
  agentName: '',
  agentNumber: '',
  sourceId: FilterOptionValue.EmptyOption(),
  statement: EmptyDateRange,
};

export type FilterEnum = {
  name: string;
  value: string;
};

export type CommissionFilter = {
  agentName: string;
  agentNumber: string;
  statement: DateRange;
  sourceId: FilterOptionUnion;
};

type CommissionState = {
  commissions: AsyncPage<Page<Commission>>;
  commissionsFilter: CommissionFilter;
  sort: O.Option<Sort>;
  sisenseWatToken: string;
  isComplete: boolean;
};

export const DEFAULT_STATE: CommissionState = {
  commissions: new Empty(),
  commissionsFilter: EmptyCommissionFilter,
  sort: O.none,
  sisenseWatToken: "",
  isComplete: false,
};

type CommissionAction =
  | ReturnType<typeof getEarnedCommissions>
  | ReturnType<typeof getAdvancedCommissions>
  | ReturnType<typeof changeAdvancedCommissions>
  | ReturnType<typeof getSisenseCommissions>
  | ReturnType<typeof changeSisenseCommissions>
  | ReturnType<typeof isSisenseComplete>
  | ReturnType<typeof changeCommissionFilter>
  | ReturnType<typeof changeSort>
  | ReturnType<typeof changeEarnedCommissions>;

export default (state: CommissionState = DEFAULT_STATE, action: CommissionAction): CommissionState => {
  switch (action.type) {
    case CommissionActionType.CHANGE_COMMISSION_FILTER:
      return {
        ...state,
        commissionsFilter: action.payload.commissionFilter,
      };
    case CommissionActionType.CHANGE_SORT:
      return {
        ...state,
        sort: O.fromNullable(action.payload.sort),
      };
    case CommissionActionType.CHANGE_EARNED_COMMISSIONS:
      return {
        ...state,
        commissions: action.payload,
      };
    case CommissionActionType.CHANGE_ADVANCED_COMMISSIONS:
      return {
        ...state,
        commissions: action.payload,
      };
      case CommissionActionType.SISENSE_IS_COMPLETE:
        return {
          ...state,
          isComplete: action.payload.isComplete,
        };
      case CommissionActionType.CHANGE_SISENSE_COMMISSIONS:
        return {
          ...state,
          sisenseWatToken: action.payload,
        };
    default:
      return state;
  }
};
